/* eslint-disable import/no-anonymous-default-export */
import {
  GET_CMS_SUCURSALES,
  GET_CMS_CONVENIOS,
  CALCULAR_CREDITO,
  CALCULAR_CREDITO_ERROR,
  GET_ALL_CREDITOS,
  GET_ALL_CREDITOS_ERROR,
  GET_CMS_INFO_CREDITOS_PERSONALES,
  GET_CMS_INFO_CREDITOS_HIPOTECARIOS,
  GET_CMS_INFO_CREDITOS_PRODUCTIVOS,
  GET_CMS_INFO_AHORROS_PROGRAMADOS,
  GET_ALL_SERVIAHORRO,
  GET_ALL_SERVIAHORRO_ERROR,
  GET_CMS_INVERSIONES,
  GET_CMS_HISTORIA,
  GET_CMS_HISTORIA_ERROR,
  GET_CMS_DELEGADOS,
  GET_CMS_PLANES_ASISTENCIA,
  GET_CMS_PLANES_ASISTENCIA_ERROR,
  GET_CMS_TARJETAS,
  GET_CMS_TARJETAS_ERROR,
  GET_CMS_BIENES_BANNER,
  GET_CMS_BIENES_BANNER_ERROR,
  GET_CMS_AFILIACION,
  GET_CMS_ORGANIZACION,
  GET_CMS_TIPS_SEGURIDAD,
  GET_CMS_TIPS_SEGURIDAD_ERROR,
  GET_CMS_FIRMA_DIGITAL,
  GET_CMS_FIRMA_DIGITAL_ERROR,
  GET_CMS_REGLAMENTOS,
  GET_CMS_REGLAMENTOS_ERROR,
  GET_CMS_PROMOCIONES,
  GET_CMS_PROMOCIONES_ERROR,
  GET_CMS_RESUME_BANNER,
  GET_CMS_RESUME_BANNER_ERROR,
  GET_CMS_COMUNICADOS,
  GET_CMS_COMUNICADOS_ERROR,
  GET_CMS_GESTION_PAGOS,
  GET_CMS_GESTION_PAGOS_ERROR
} from "../actions/types";
import { GET_CMS_CONTACTENOS } from "../../components/Contactenos/store/actions/types";
const initialState = [];

const ahorroYCreditoReducer = function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_CMS_SUCURSALES:
      return {
        ...state,
        sucursalesCMS: payload,
      };
    case GET_CMS_CONVENIOS:
      return {
        ...state,
        conveniosCMS: payload,
      };
    case CALCULAR_CREDITO:
      return {
        ...state,
        calculadoraCredito: payload,
      };
    case CALCULAR_CREDITO_ERROR:
      return {
        ...state,
        calculadoraCredito: payload,
      };
    case GET_ALL_CREDITOS:
      return {
        ...state,
        creditos: payload,
      };
    case GET_ALL_CREDITOS_ERROR:
      return {
        ...state,
        creditos: payload,
      };
    case GET_CMS_CONTACTENOS:
      return {
        ...state,
        contactenos: payload.data,
      };
    case GET_ALL_SERVIAHORRO:
      return {
        ...state,
        serviahorro: payload,
      };
    case GET_ALL_SERVIAHORRO_ERROR:
      return {
        ...state,
        serviahorro: payload,
      };
    case GET_CMS_INVERSIONES:
      return {
        ...state,
        inversiones: payload,
      };
    case GET_CMS_HISTORIA:
      return {
        ...state,
        historia: payload.data,
      };
    case GET_CMS_HISTORIA_ERROR:
      return {
        ...state,
        historia: payload,
      };
    case GET_CMS_DELEGADOS:
      return { ...state, delegados: payload.data };
    case GET_CMS_PLANES_ASISTENCIA:
      return {
        ...state,
        planesAsistencia: payload.data.plandeAsistencia,
      };
    case GET_CMS_PLANES_ASISTENCIA_ERROR:
      return {
        ...state,
        planesAsistencia: payload,
      };
    case GET_CMS_INFO_CREDITOS_PERSONALES:
      return {
        ...state,
        creditosPersonales: payload.data,
      };
    case GET_CMS_INFO_CREDITOS_PRODUCTIVOS:
      return {
        ...state,
        creditosProductivos: payload.data,
      };
    case GET_CMS_INFO_CREDITOS_HIPOTECARIOS:
      return {
        ...state,
        creditosHipotecarios: payload.data,
      };
    case GET_CMS_INFO_AHORROS_PROGRAMADOS:
      return {
        ...state,
        ahorrosProgramados: payload.data,
      };
    case GET_CMS_TARJETAS:
      return {
        ...state,
        tarjetasCredito: payload.data.aCTarjetadeCredito,
      };
    case GET_CMS_TARJETAS_ERROR:
      return {
        ...state,
        tarjetasCredito: payload,
      };
    case GET_CMS_BIENES_BANNER:
      return {
        ...state,
        bienesBanner: payload,
      };
    case GET_CMS_BIENES_BANNER_ERROR:
      return {
        ...state,
        bienesBanner: payload,
      };
    case GET_CMS_AFILIACION:
      return {
        ...state,
        afiliacionCMS: payload.data,
      };
    case GET_CMS_ORGANIZACION:
      return {
        ...state,
        organizacion: payload.data,
      };
    case GET_CMS_TIPS_SEGURIDAD:
      return {
        ...state,
        tipsSeguridad: payload.data.aCTipsdeSeguridad,
      };
    case GET_CMS_TIPS_SEGURIDAD_ERROR:
      return {
        ...state,
        tipsSeguridad: payload,
      };
    case GET_CMS_FIRMA_DIGITAL:
      return {
        ...state,
        firmaDigital: payload.data,
      };
    case GET_CMS_FIRMA_DIGITAL_ERROR:
      return {
        ...state,
        firmaDigital: payload,
      };
    case GET_CMS_REGLAMENTOS:
      return {
        ...state,
        reglamentos: payload.data,
      };
    case GET_CMS_REGLAMENTOS_ERROR:
      return {
        ...state,
        reglamentos: payload,
      };
    case GET_CMS_PROMOCIONES:
      return {
        ...state,
        promociones: payload.data,
      };
    case GET_CMS_PROMOCIONES_ERROR:
      return {
        ...state,
        promociones: payload,
      };
    case GET_CMS_RESUME_BANNER:
      return {
        ...state,
        resumeBanner: payload?.data?.aCResumen[0]?.resumElements?.contentItems,
      };
    case GET_CMS_RESUME_BANNER_ERROR:
      return {
        ...state,
        resumeBanner: payload,
      };
    case GET_CMS_COMUNICADOS:
      return {
        ...state,
        comunicadosOficiales: payload?.data?.aCComunicadosOficiales,
      };
    case GET_CMS_COMUNICADOS_ERROR:
      return {
        ...state,
        comunicadosOficiales: payload,
      };
    case GET_CMS_GESTION_PAGOS:
      return {
        ...state,
        gestionPagos: payload?.data?.aCGestionPagos[0],
      };
    case GET_CMS_GESTION_PAGOS_ERROR:
      return {
        ...state,
        gestionPagos: payload,
      };  
    default:
      return state;
  }
};

export default ahorroYCreditoReducer;
